<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      v-loading="isBusy"
      element-loading-spinner="el-icon-loading"
      label-width="170px"
    >
      <el-collapse v-model="collapse" accordion @change="handleChange">
        <el-collapse-item title="Phone Number" name="phoneNumber">
          <el-form-item label="Phone number" prop="phone_number">
            <el-select v-model="form.phone_number"
                       class="w-100"
                       filterable
                       clearable
                       remote
                       allow-create
                       default-first-option
                       placeholder="Search"
                       :remote-method="searchContact"
                       :loading="contactsLoading"
            >
              <el-option
                v-for="item in contactOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item title="Email" name="email">
          <el-form-item label="Email" prop="email">
            <el-select v-model="form.email"
                       class="w-100"
                       filterable
                       clearable
                       remote
                       allow-create
                       default-first-option
                       placeholder="Search"
                       :remote-method="searchContact"
                       :loading="contactsLoading"
            >
              <el-option
                v-for="item in contactOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-collapse-item>
      </el-collapse>
      <el-form-item label="Brand" prop="brand_id" class="mt-3">
        <el-select v-model="form.brand_id"
                   class="w-100"
                   clearable
                   placeholder="Brand"
        >
          <el-option
            v-for="item in brandOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <button class="btn btn-create px-4" @click="store">Store</button>
  </div>
</template>

<script>
import BaseForm from '../form';
import InputMixin from '../../mixins/inputs';

export default {
  extends: BaseForm,

  props: {
    searchContactUrl: String,
    initialContacts: Array,
    brandOptions: Array,
  },

  data() {
    const form = {
      phone_number: null,
      brand_id: null,
      email: null,
    };

    return {
      form,
      rules: _.mapValues(form, () => [{validator: this.fieldExternalValidator}]),
      contacts: this.initialContacts || [],
      contactsLoading: false,
      collapse: 'phoneNumber',
    }
  },

  computed: {
    /**
     * @return {array}
     */
    contactOptions() {
      return _.map(this.contacts, ({phone_number, full_name = '', email}) => {
        if (this.collapse === 'email') {
          return {
            value: email,
            label: `${email} (${full_name})`,
          };
        }

        return {
          value: phone_number,
          label: `${phone_number} (${full_name})`,
        };
      });
    }
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm({phone_number = null, brand_id = null, email = null}) {
      this.form = {
        phone_number,
        brand_id,
        email,
      };
    },

    /**
     * @param {String} text
     */
    searchContact(text) {
      this.contactsLoading = true;

      let params = {
        text: text,
      };

      if (this.collapse === 'email') {
        params = _.defaults(params, {
          nonNullEmail: true,
        });
      }

      axios.get(this.searchContactUrl, {params: params})
        .then(({data: {data}}) => this.contacts = data)
        .catch(() => this.contacts = [])
        .finally(() => this.contactsLoading = false);
    },

    /**
     * @return {undefined}
     */
    handleChange() {
      this.contacts = [];
      this.phone_number = null
      this.email = null;
    },
  },

  mixins: [
    InputMixin,
  ],
}
</script>
